import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api';

export default function ForgotPassword() {
  const [email,     setEmail]     = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);

  const handleSubmit = async () => {
    if (!email) return setError('Please enter your email address.');
    setError('');
    setLoading(true);
    try {
      await forgotPassword({ email });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      minHeight:      '100vh',
      background:     '#f9fafb',
    }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 24px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <span style={{ fontSize: 48 }}>🛡️</span>
          <h1 style={{ margin: '8px 0 4px', fontSize: 28, fontWeight: 700, color: '#111827' }}>
            RegShield
          </h1>
          <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>
            Compliance Platform — Luxembourg
          </p>
        </div>

        {/* Card */}
        <div style={{
          background:   'white',
          borderRadius: 12,
          padding:      '32px',
          boxShadow:    '0 4px 24px rgba(0,0,0,0.08)',
          border:       '1px solid #f0f0f0',
        }}>
          {submitted ? (
            <>
              {/* Success state */}
              <div style={{
                textAlign:    'center',
                padding:      '8px 0 16px',
              }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>📬</div>
                <h2 style={{ margin: '0 0 12px', fontSize: 18, fontWeight: 600, color: '#111827' }}>
                  Check your inbox
                </h2>
                <p style={{ margin: '0 0 24px', fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>
                  If <strong>{email}</strong> is registered, you'll receive a reset link shortly.
                </p>
                <Link to="/login" style={{
                  display:      'inline-block',
                  padding:      '10px 24px',
                  borderRadius: 8,
                  background:   '#1e3a5f',
                  color:        'white',
                  textDecoration: 'none',
                  fontSize:     14,
                  fontWeight:   600,
                }}>
                  Back to login
                </Link>
              </div>
            </>
          ) : (
            <>
              <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600, color: '#111827' }}>
                Forgot your password?
              </h2>
              <p style={{ margin: '0 0 24px', fontSize: 14, color: '#6b7280' }}>
                Enter your email and we'll send you a reset link.
              </p>

              {error && (
                <div style={{
                  background:   '#fee2e2',
                  border:       '1px solid #fca5a5',
                  borderRadius: 8,
                  padding:      '10px 14px',
                  marginBottom: 20,
                }}>
                  <p style={{ margin: 0, fontSize: 13, color: '#991b1b', fontWeight: 500 }}>
                    {error}
                  </p>
                </div>
              )}

              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                  Email address
                </label>
                <input
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                  style={{
                    width:        '100%',
                    padding:      '10px 12px',
                    borderRadius: 8,
                    border:       '1px solid #e5e7eb',
                    fontSize:     14,
                    color:        '#111827',
                    outline:      'none',
                    boxSizing:    'border-box',
                  }}
                />
              </div>

              <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  width:        '100%',
                  padding:      '11px',
                  borderRadius: 8,
                  background:   loading ? '#93c5fd' : '#1e3a5f',
                  color:        'white',
                  border:       'none',
                  fontSize:     14,
                  fontWeight:   700,
                  cursor:       loading ? 'not-allowed' : 'pointer',
                  transition:   'background 0.15s',
                }}
              >
                {loading ? 'Sending…' : 'Send reset link'}
              </button>

              <p style={{ textAlign: 'center', marginTop: 16, margin: '16px 0 0' }}>
                <Link to="/login" style={{ color: '#1e3a5f', textDecoration: 'none', fontSize: 13, fontWeight: 500 }}>
                  ← Back to login
                </Link>
              </p>
            </>
          )}
        </div>

        {/* Footer */}
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: '#9ca3af' }}>
          RegShield — CSSF · DORA · GDPR Compliant
        </p>

      </div>
    </div>
  );
}